import React from 'react';
import { t } from 'i18next';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router-dom';

export function CourseTabs({ selectedTab }) {
  const navigate = useNavigate();
  const tabs = [
    { value: 'curso', label: t('courses.toggleMyCourses'), path: '/curso' },
    // { value: 'recomendado', label: 'Recomendados', path: '/curso/recomendado' },
    { value: 'certificados', label: t('lms.toggleCertifications'), path: '/curso/certificado' }
  ];

  return (
    <Tabs defaultValue={selectedTab}>
      <TabsList className="mb-8">
        {tabs.map(tab => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
